module.exports = __webpack_public_path__ + "static/img/mianbu@3x.1a05696.png";


//////////////////
// WEBPACK FOOTER
// ./static/icons/mianbu@3x.png
// module id = ir87
// module chunks = 1